<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="10 offset-1">
          <div class="dj-page-head">
            <div class="dj-page-head__text">
              <h1 class="dj-page-title">Dashboard</h1>
              <p class="dj-page-sub">
                Budget, service and spare-cost overview by project
              </p>
            </div>
          </div>
          <v-row>
            <v-col md="10">
              <v-autocomplete
                ref="projects"
                dense
                v-model="form.project_id"
                :items="projectItems"
                label="Select Project"
                messages="Kindly Select any project"
                prepend-inner-icon="mdi-content-paste"
                outlined
                @change="getData()"
              ></v-autocomplete>
            </v-col>
            <v-col md="2">
              <router-link :to="`/dashboards/show-all`">Show All</router-link>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-row v-else>
        <v-col md="10 offset-1" v-if="form.project_id">
          <v-card elevation="6">
            <v-row class="px-5">
              <v-col md="6">
                <v-row>
                  <v-col md="4">
                    <v-img
                      :src="`${mediaUrl + project.logo}`"
                      style="height: 90px; width: 100px; border-radius: 100%"
                    ></v-img>
                  </v-col>
                  <v-col md="5" class="mt-8">
                    Project Name : {{ project.name }}
                  </v-col>
                  <v-col md="3" class="mt-8">
                    Port Name :
                    {{ project.port ? project.port.description : "" }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="6" class="mt-8">
                <v-row>
                  <v-col md="6"
                    >Estimate start date : {{ project.estimated_date }}</v-col
                  >
                  <v-col md="6">Signature: {{ project.signature }}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="px-5">
              <v-col md="12">
                <v-simple-table fixed-header>
                  <!-- :height="`${valueLists.length ? '370px' : ''}`" -->
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Sr No</th>
                        <th class="text-left">Category</th>
                        <th class="text-left">Allocated Budget</th>
                        <th class="text-left">Expected Service</th>
                        <th class="text-left">Total Service</th>
                        <th class="text-left">Total Spare Cost</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, i) in treeData" :key="`data${i}`">
                        <td>{{ i + 1 }}</td>
                        <td>
                          {{ data.name }}
                        </td>
                        <td>
                          {{
                            data.allocated_budget ? data.allocated_budget : 0
                          }}
                        </td>
                        <td>
                          {{
                            data.expected_service ? data.expected_service : 0
                          }}
                        </td>
                        <td>
                          {{ data.total_expense ? data.total_expense : 0 }}
                        </td>
                        <td>
                          {{
                            data.total_spare_cost ? data.total_spare_cost : 0
                          }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td></td>
                        <td></td>
                        <td style="font-weight: bold">
                          {{ grand_allocated_budget }}
                        </td>
                        <td style="font-weight: bold">
                          {{ grand_expected_service }}
                        </td>
                        <td style="font-weight: bold">
                          {{ grand_total_expense }}
                        </td>
                        <td style="font-weight: bold">
                          {{ grand_total_spare_cost }}
                        </td>
                      </tr>
                    </tfoot>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="10 offset-1" v-if="categoryWiseChart.length">
          <v-card elevation="6">
            <v-card-title>
              Category wise chart &nbsp;&nbsp;
              <v-col sm="3">
                <v-select
                  v-model="isChart"
                  prepend-inner-icon="mdi-chart-bar"
                  :items="chartItems"
                  outlined
                  label="Select Chart"
                  dense
                  hide-details="auto"
                >
                </v-select>
              </v-col>
            </v-card-title>
            <v-card-text v-if="isChart == 'Column'">
              <GChart
                type="ColumnChart"
                :data="categoryWiseChart"
                :options="columnchartOptions"
              />
            </v-card-text>
            <v-card-text v-if="isChart == 'Bar'">
              <GChart
                type="BarChart"
                :data="categoryWiseChart"
                :options="barchartOptions"
              />
            </v-card-text>
            <v-card-text v-if="isChart == 'Line'">
              <GChart
                type="LineChart"
                :data="categoryWiseChart"
                :options="linechartOptions"
              />
            </v-card-text>
            <v-card-text v-if="isChart == 'Pie'">
              <GChart
                type="PieChart"
                :data="categoryWiseChart"
                :options="piechartOptions"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="10 offset-1" v-if="categoryWiseChart.length">
          <v-card elevation="6">
            <v-card-title>
              Spare Cost chart&nbsp;&nbsp;
              <v-col sm="3">
                <v-select
                  v-model="isSpareChart"
                  prepend-inner-icon="mdi-chart-bar"
                  :items="chartItems"
                  outlined
                  label="Select Chart"
                  dense
                  hide-details="auto"
                >
                </v-select>
              </v-col>
            </v-card-title>
            <v-card-text v-if="isSpareChart == 'Column'">
              <GChart
                type="ColumnChart"
                :data="spareCostChart"
                :options="columnchartOptions"
              />
            </v-card-text>
            <v-card-text v-if="isSpareChart == 'Bar'">
              <GChart
                type="BarChart"
                :data="spareCostChart"
                :options="barchartOptions"
              />
            </v-card-text>
            <v-card-text v-if="isSpareChart == 'Line'">
              <GChart
                type="LineChart"
                :data="spareCostChart"
                :options="linechartOptions"
              />
            </v-card-text>
            <v-card-text v-if="isSpareChart == 'Pie'">
              <GChart
                type="PieChart"
                :data="spareCostChart"
                :options="piechartOptions"
              />
            </v-card-text>
            <!-- <v-card-text>
              <GChart
                type="ColumnChart"
                :data="spareCostChart"
                :options="columnchartOptions"
              />
            </v-card-text> -->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
export default {
  name: "ModulesPage",
  data() {
    return {
      form: {
        project_id: "",
        type: "",
      },
      isChart: "",
      isSpareChart: "",
      chartItems: [
        { id: 0, text: "Select Chart", value: "0" },
        { id: "Bar", text: "Bar Chart", value: "Bar" },
        { id: "Column", text: "Column Chart", value: "Column" },
        { id: "Line", text: "Line Chart", value: "Line" },
        { id: "Pie", text: "Pie Chart", value: "Pie" },
      ],

      // Tree data For treeview
      treeData: [],
      modules: [],
      categoryWiseChart: [],
      spareCostChart: [],
      project: [],
      // grand_total_expense: 0,

      projectItems: [{ id: 0, text: "Select Project", value: "0" }],
      statusItems: [
        { id: "0", text: "Inprogress", value: 0 },
        { id: "1", text: "Waiting for spares", value: 1 },
        { id: "2", text: "Completed", value: 2 },
        { id: "3", text: "Waiting for Confirmation", value: 3 },
      ],

      isLoading: false,

      columnchartOptions: {
        annotations: {
          textStyle: {
            fontSize: 10,
          },
          minValue: 0,
        },
        vAxis: {
          gridlines: {
            color: "transparent",
          },
          textStyle: {
            fontSize: 10,
          },
        },
        hAxis: {
          gridlines: {
            color: "transparent",
          },
        },
        legend: { position: "top", alignment: "center" },
        width: 1900,
        height: 600,
      },
      barchartOptions: {
        hAxis: {
          gridlines: {
            color: "transparent",
          },
          minValue: 0,
        },
        vAxis: {
          gridlines: {
            color: "transparent",
          },
          textStyle: {
            fontSize: 10,
          },
        },
        legend: { position: "top", alignment: "center" },
        width: 1900,
        height: 600,
      },
      linechartOptions: {
        curveType: "function",
        hAxis: {
          gridlines: {
            color: "transparent",
          },
          minValue: 0,
        },
        vAxis: {
          gridlines: {
            color: "transparent",
          },
          textStyle: {
            fontSize: 10,
          },
        },
        legend: { position: "top", alignment: "center" },
        width: 1900,
        height: 600,
      },
      piechartOptions: {
        width: 1900,
        height: 600,
      },
    };
  },
  mounted() {
    this.form.type = this.$route.query.type;
    if (this.$route.query.logged_in) {
      this.logged_in_as = this.$route.query.logged_in;
    }
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get(
        `modules/masters?category_type=${this.$route.query.type}`
      );
      masters = masters.data;

      masters.projects.forEach((project) => {
        if (this.roleName == "Handler") {
          if (
            project.created_by_id == this.user.id &&
            project.type == "PROJECT"
          ) {
            this.projectItems.push({
              id: project.id,
              text: project.name,
              value: project.id,
            });
          }
        } else {
          if (project.type == "PROJECT") {
            this.projectItems.push({
              id: project.id,
              text: project.name,
              value: project.id,
            });
          }
        }
      });
    },
    async getData() {
      this.modules = [];
      this.treeData = [];
      this.categoryWiseChart = [];
      this.spareCostChart = [];
      this.isLoading = true;
      let modules = [];
      let project = await axios.get(`/projects/${this.form.project_id}`);
      this.project = project.data.data;
      modules = await axios.get(`modules?project_id=${this.form.project_id}`);
      this.modules = modules.data.data;
      if (this.modules.length > 0) {
        this.modules.forEach((module) => {
          let module_name = module.category.name;
          let allocated_budget = module.allocated_budget
            ? module.allocated_budget
            : 0;
          // if (module.sub_category) {
          //   module_name = module_name;
          // }
          // if (
          //   module.module_jobs.length > 0 &&
          //   module.category.name != "SPARES"
          // ) {
          //   module_name = module_name;
          // }
          // if (
          //   module.module_jobs.length > 0 &&
          //   module.category.name == "SPARES"
          // ) {
          //   module_name = module_name;
          // }
          let m = {
            id: module.id,
            name: module_name,
            children: [],
            total_expense: 0,
            expected_service: 0,
            total_spare_cost: 0,
            allocated_budget: allocated_budget,
          };
          // console.log(m);
          // this.grand_total_expense = 0;
          if (module.module_jobs.length > 0) {
            let total_expense = 0;
            let expected_service = 0;
            module.module_jobs.forEach((moduleJob) => {
              let module_job_name = moduleJob.name;
              if (moduleJob.total_cost) {
                total_expense += parseInt(moduleJob.total_cost);

                // module_job_name =
                //   module_job_name + " || SEV: " + moduleJob.total_cost;
              }
              if (moduleJob.expected_cost) {
                expected_service += parseInt(moduleJob.expected_cost);
              }
              if (
                moduleJob.module_job_spares.length &&
                module.category.name != "SPARES"
              ) {
                let total_spare_cost = 0;
                moduleJob.module_job_spares.forEach((mjs) => {
                  total_spare_cost += parseInt(mjs.total_cost);
                });
                m.total_spare_cost = total_spare_cost;
              }
              // if (
              //   moduleJob.module_job_spares.length &&
              //   module.category.name == "SPARES"
              // ) {
              //   let total_spare_cost = 0;
              //   moduleJob.module_job_spares.forEach((mjs) => {
              //     total_spare_cost += parseInt(mjs.total_cost);
              //   });
              //   module_job_name = " SPA: " + total_spare_cost;
              //   // this.title = module.category.name;
              // }
              // let title;

              m.total_expense = total_expense;
              m.expected_service = expected_service;
              let mj = {
                id: module.id + "-" + moduleJob.id,
                name: module_job_name,
                // title: this.title,
                children: [],
              };
              /** Add if Any Sub jobs Present */
              moduleJob.module_jobs.forEach((smj) => {
                let module_job_name = smj.name;
                if (smj.total_cost) {
                  module_job_name =
                    module_job_name + " || SEV: " + smj.total_cost;
                }
                if (
                  smj.module_job_spares.length &&
                  smj.category.name != "SPARES"
                ) {
                  let total_spare_cost = 0;
                  smj.module_job_spares.forEach((mjs) => {
                    total_spare_cost += parseInt(mjs.total_cost);
                  });
                  module_job_name =
                    module_job_name + " || SPA: " + total_spare_cost;
                }
                if (
                  smj.module_job_spares.length &&
                  smj.category.name == "SPARES"
                ) {
                  let total_spare_cost = 0;
                  smj.module_job_spares.forEach((mjs) => {
                    total_spare_cost += parseInt(mjs.total_cost);
                  });
                  module_job_name = " SPA: " + total_spare_cost;
                }
                let child = {
                  id: module.id + "-" + moduleJob.id + "-" + smj.id,
                  name: module_job_name,

                  children: [],
                };
                mj.children.push(child);
              });
              m.children.push(mj);
            });
          }
          this.treeData.push(m);
        });
        this.grand_total_expense = 0;
        this.grand_expected_service = 0;
        this.grand_total_spare_cost = 0;
        this.grand_allocated_budget = 0;
        this.treeData.forEach((mm) => {
          this.grand_total_expense += parseInt(mm.total_expense);
          this.grand_expected_service += parseInt(mm.expected_service);
          this.grand_total_spare_cost += parseInt(mm.total_spare_cost);
          this.grand_allocated_budget += parseInt(mm.allocated_budget);
        });
      }

      let categoryWiseChart = [
        ["Category", "Allocated Budeget", "Expected Service", "Total Service"],
      ];
      let spareCostChart = [["Category", "Spare Cost"]];
      this.treeData.forEach((data) => {
        categoryWiseChart.push([
          data.name,
          data.allocated_budget,
          data.expected_service,
          data.total_expense,
        ]);
        spareCostChart.push([data.name, data.total_spare_cost]);
      });
      this.categoryWiseChart = categoryWiseChart;
      this.spareCostChart = spareCostChart;
      this.isLoading = false;
    },
    capitalize(string) {
      if (string) {
        let capitalized_string =
          string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        return capitalized_string;
      }
    },
    calculated(selectedNode) {
      let total_cost = parseInt(selectedNode.qty) * parseInt(selectedNode.cost);
      if (selectedNode.discount_percentage) {
        total_cost =
          total_cost -
          (total_cost * parseInt(selectedNode.discount_percentage)) / 100;
      }
      if (selectedNode.discount_amount)
        total_cost = total_cost - parseInt(selectedNode.discount_amount);
      if (selectedNode.additional_percentage) {
        total_cost =
          total_cost +
          (total_cost * parseInt(selectedNode.additional_percentage)) / 100;
      }
      if (selectedNode.additional_amount)
        total_cost = total_cost + parseInt(selectedNode.additional_amount);
      selectedNode.total_cost = total_cost;
    },
    calculated_total(spare) {
      spare.total_cost =
        parseInt(spare.cost) + parseInt(spare.transportation_cost);
    },
  },
};
</script>
